import { connect } from 'react-redux';
import { getIsLoggedIn } from '../../../../publicSession/selectors';
import { restrictLoggedOut } from '../../../../redux/loggedout';
import { ReferralType } from '@wix/da-bi/pkg/constants';
var mapStateToProps = function (state) { return ({
    isLoggedIn: getIsLoggedIn(state),
}); };
var mapDispatchToProps = {
    restrictLoggedOut: function () {
        return restrictLoggedOut({ restrictedActionName: ReferralType.ANON_DOWNLOAD });
    },
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=PcpButtonWithPopover.container.js.map